export default __webpack_public_path__ + "static/media/03.85cdc0b7.jpg";